import React, { useEffect } from "react";
import ClassCard from "../../../../../../../components/Common/ClassCard/ClassCard";
import Loader from "../../../../../../../components/Common/Loader/Loader";
import Modal from "../../../../../../../components/Common/Modal/Modal";
import classes from "./ShotclassCollection.module.scss";

const ShotclassCollection = ({
  shotclassCollection,
  shotclassModalOpen,
  setShotclassModalOpen,
  setShotclassCollection,
}) => {
  useEffect(() => {
    return () => {
      setShotclassCollection(null);
    };
  }, [setShotclassCollection]);

  return (
    <Modal
      isOpen={shotclassModalOpen}
      heading={"View Series"}
      toggle={() => setShotclassModalOpen(false)}
      width={"80"}
    >
      {shotclassCollection?.length > 0 ? (
        <div className={classes.shotclassCollection}>
          {shotclassCollection?.map((data) => (
            <ClassCard shotClassData={data?.ShotClass} />
          ))}
        </div>
      ) : (
        <div className={classes.loader}>
          <Loader />
        </div>
      )}
    </Modal>
  );
};

export default ShotclassCollection;
